import { isAvailable, FDealType, FOfferType } from '../../../../../packages/JsonQuery';
import { IFilterSet, TFilter } from 'shared/types/filters';

const OFFER_TYPE = FOfferType.Flat;

export const MIXED_FLAT_FILTERS_SET: IFilterSet<TFilter>[] = [
  {
    availability: isAvailable(FDealType.Sale, OFFER_TYPE),
    list: ['dealType', 'offerType', 'roomType', 'price', 'advancedFilters', 'geo'],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, OFFER_TYPE),
    list: ['dealType', 'offerType', 'roomType', 'price', 'advancedFilters', 'geo'],
  },
  {
    availability: isAvailable(FDealType.RentDaily, OFFER_TYPE),
    list: ['dealType', 'dates', 'beds', 'offerType', 'roomType', 'price', 'advancedFilters', 'geo'],
  },
];
